/**
 * Exports the file with input data, file name and file format.
 * @param dataString sima data string
 * @param name file name
 * @param fileFormat
 */
export function exportData(dataString, name, fileFormat) {
    // Create a Blob with the data
    const blob = new Blob([dataString], { type: "text/plain" });
    // Create a link element
    const link = document.createElement("a");
    link.download = name + fileFormat; // Specify the file name
    link.href = window.URL.createObjectURL(blob);
    // Append the link to the body and trigger the download
    document.body.appendChild(link);
    link.click();
    // Clean up
    document.body.removeChild(link);
}
//# sourceMappingURL=exportFile.js.map